// extracted by mini-css-extract-plugin
export default {"cardsContainer":"teamsProfile_cardsContainer__uttqh","profileMenu":"teamsProfile_profileMenu__01uTL","createButton":"teamsProfile_createButton__wRhi8"};